export const BASIC_ROLES = Object.freeze(['dashboard', 'profile'])

// Canonical roles surfaced in UI (employee role toggles, menu sections, etc.)
export const ROLES = Object.freeze([
  'leadership',
  'coordination',
  'product',
  'support',
  'guide',
  'finance',
  'growth',
  'storytelling',
  'technical',
])

export const ROLE_LABELS = Object.freeze({
  leadership: 'Leadership',
  coordination: 'Coordination',
  product: 'Product',
  support: 'Support',
  guide: 'Guide',
  finance: 'Finance',
  growth: 'Growth',
  storytelling: 'Storytelling',
  technical: 'Technical',
})

export function isBasicRole(value) {
  return typeof value === 'string' && BASIC_ROLES.includes(value)
}

export function emptyRolesDoc() {
  return ROLES.reduce((acc, key) => {
    acc[key] = false
    return acc
  }, {})
}

export function hasRole(permissions, roleKey) {
  if (isBasicRole(roleKey)) return true
  if (!permissions || typeof permissions !== 'object') return false
  return !!permissions[roleKey]
}
